const TitleModal = (props: any) => {
  let title = props.title ?? "";
  let className = props.className ?? "";
  return (
    <h5 className={`TitleModal ${className}`} >{title}</h5 >
  )
}

export default TitleModal